import React, { useRef } from "react";
import "./cards.css";

const AnimatedButton = ({ onClick }) => {
  const buttonRef = useRef(null);

  const handleClick = (e) => {
    e.preventDefault();

    const button = buttonRef.current;
    if (!button) return;

    button.classList.add("animate");

    setTimeout(() => {
      button.classList.remove("animate");
      if (onClick) {
        onClick();
      }
    }, 600);
  };

  return (
    <button ref={buttonRef} className="button" onClick={handleClick} data-bs-toggle="tooltip" data-bs-placement="right" title="More details">
      More Info..
    </button>
  );
};

export default AnimatedButton;
